/* RESPONSIBLE TEAM: team-frontend-tech */
import { helper as buildHelper } from '@ember/component/helper';
import { isPresent } from '@ember/utils';

export default buildHelper(function (objects) {
  return Object.assign({}, ...objects.filter((object) => isPresent(object)));
});
